import { Tooltip } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid";

import { useState } from "react";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import WithdrawModal from "../modals/WithdrawModal";
import { Ownership } from "../../../../apis/__generated__/graphql";

export interface WithdrawButtonProps {
  refetch: () => void;
  row?: Ownership;
  disabled: boolean;
  onSelectedRow: () => void;
  onUnselectedRow: () => void;
}

export default function WithdrawButton({
  refetch,
  row,
  disabled,
  onSelectedRow,
  onUnselectedRow,
}: WithdrawButtonProps) {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
    onSelectedRow();
  };

  const handleClose = () => {
    setOpen(false);
    onUnselectedRow();
  };

  return (
    <>
      <GridActionsCellItem
        label="Withdraw"
        icon={
          <Tooltip title="Withdraw">
            <CurrencyExchangeIcon />
          </Tooltip>
        }
        onClick={handleOpen}
        disabled={disabled}
      />
      {row && (
        <WithdrawModal
          row={row}
          open={open}
          onClose={handleClose}
          refetch={refetch}
        />
      )}
    </>
  );
}
